module.exports = __webpack_public_path__ + "static/anna-is-a-sunflower-95e70567099abb0fad8e3055d19cae0e.jpg";